const FluxStatisticsMessages = require('./messages')
const FluxStatisticsContacts = require('./contacts')
const FluxStatisticsChats = require('./chats')
const FluxStatisticsSurvey = require('./survey')

class FluxStatistics {
  constructor(document) {
    document = document || {}
    this.messages = new FluxStatisticsMessages(document.messages)
    this.contacts = new FluxStatisticsContacts(document.contacts)
    this.chats = new FluxStatisticsChats(document.chats)
    this.survey = new FluxStatisticsSurvey(document.survey)
  }
}

module.exports = FluxStatistics
